import React from 'react';

const OfferLetterTemplate = ({ data, positionType }) => {
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const day = date.getDate();
    const suffix = day === 1 || day === 21 || day === 31 ? 'st' : 
                   day === 2 || day === 22 ? 'nd' : 
                   day === 3 || day === 23 ? 'rd' : 'th';
    const month = date.toLocaleDateString('en-US', { month: 'long' });
    const year = date.getFullYear();
    return `${day}${suffix} ${month} ${year}`;
  };

  return (
    <div id="offer-letter" className="offer-letter-template">
      {/* Page 1 */}
      <div className="offer-page">
        <div className="offer-header">
          <div className="offer-logo-section">
            <div className="offer-logo">
              <img src="/uploads/logo.png" alt="Bandhan Guru Logo" />
            </div>
          </div>
          <div className="offer-company-info">
            <h1>BANDHANGURU</h1>
            <p>OFFICE NO. 12125, GAUR CITY MALL, GREATER NOIDA WEST, GAUTAM BUDH NAGAR,<br />UTTAR PRADESH - 201318</p>
            <div className="offer-contact-info">
              <div>
                <img src="/uploads/qr.png" alt="QR Code" className="offer-qr-code" />
              </div>
              <div className="offer-contact-details">
                <p>📧 {data.websiteEmail || 'info@bandhanguru.com'}</p>
                <p>🌐 {data.website || 'www.bandhanguru.com'}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="offer-letter-content">
          <h2 className="offer-letter-title">
            {positionType === 'State Head' ? 'Offer Letter' : 'Offer Letter-cum-Joining Letter'}
          </h2>
          
          <div className="offer-date-ref">
            <p><strong>Date: {formatDate(data.date)}</strong></p>
          </div>

          <p><strong>Ref No.: {data.refNo}</strong></p>

          {positionType === 'State Head' ? (
            <div className="offer-recipient-info">
              <ul style={{ listStyle: 'none', padding: 0 }}>
                <li><strong>Name:</strong> {data.name[0].toUpperCase() + data.name.slice(1).toLowerCase()}</li>
                <li><strong>Father's Name:</strong> {data.fatherName || ''}</li>
                <li><strong>Mobile No.:</strong> {data.phone}</li>
                <li><strong>Alternate Mobile No.:</strong> {data.alternatePhone || ''}</li>
                <li><strong>Email ID:</strong> {data.email}</li>
                <li><strong>Address:</strong> {data.address}</li>
                <li><strong>Date of Joining:</strong> {formatDate(data.joiningDate)}</li>
               
              </ul>
              <p><strong>State (for Appointment):</strong> {data.state}</p>
              <p><strong>Subject: Offer of Appointment as State Head (Offer Letter Only - Not Joining Letter)</strong></p>
            </div>
          ) : (
            <div className="offer-recipient-info">
              <p>To,</p>
              <p>Mr./Ms. {data.name[0].toUpperCase() + data.name.slice(1).toLowerCase()}</p>
              <p>Address: {data.address}</p>
              <p>Phone: {data.phone}</p>
               {positionType !== "District Coordinator" && <p><strong>Date of Joining:</strong> {formatDate(data.joiningDate)}</p>}
              <p><strong>Subject: {positionType === 'Commissioner Manager' ? 'Offer for the Position of Commissionery Manager' : 'Appointment for the Position of District Coordinator'}</strong></p>
            </div>
          )}

          <p>Dear {positionType === 'State Head' ? '' : `Mr./Ms. ${data.name[0].toUpperCase() + data.name.slice(1).toLowerCase()}`},</p>

          {positionType === 'District Coordinator' && (
            <>
              <p>We are pleased to offer you the position of District Coordinator at Bandhan Guru. You will be posted in District: <strong>{data.district}</strong> and State: <strong>{data.state}</strong> and you will report either to the Commissionery Manager or directly to the State Head.</p>
              <p>{data.salaryDescription}</p>
              <p>Your duties include meeting wedding vendors, explaining Bandhan Guru services, creating vendor accounts on the platform, and selling subscription plans. You are strictly prohibited from accepting cash from any vendor. All payments must be collected through online modes only. You are also required to submit daily field activity updates and contribute to platform growth within your assigned district.</p>
            </>
          )}

          {positionType === 'Commissioner Manager' && (
            <>
              <p>This letter serves as an official offer for the position of Commissionery Manager at Bandhan Guru. You are assigned to work in the following districts:</p>
              {data.districtsList && <p><strong>Name of Districts:</strong></p>}
              {data.districtsList && (
                <ol>
                  {data.districtsList.split('\n').filter(district => district.trim()).map((district, index) => (
                    <li key={index}>{district.trim()}</li>
                  ))}
                </ol>
              ) }
            </>
          )}

          {positionType === 'State Head' && (
            <>
              <p>We are pleased to extend to you an Offer for the position of <strong>State Head for {data.state}</strong> at Bandhan Guru. Please note that this is an Offer Letter only and not a Joining Letter.</p>
              <h3>Terms & Conditions of Offer</h3>
              <ol>
                <li><strong>Condition for Issuance of Joining Letter:</strong><br />
                Your Joining Letter will be issued only after you successfully hire a minimum of 60% District Coordinators in your state (<strong>{data.state}</strong>).</li>
                <li>Specifically, in the case of Rajasthan, you must ensure division-wise hiring, such that in every district of the state, a minimum of 4 (four) District Coordinators are hired.<br />
                Only after fulfilling this requirement, your official joining letter will be issued.</li>
                <li><strong>No Salary During Pre-Joining Period:</strong><br />
                Until the issuance of your joining letter, no salary or allowance shall be payable.</li>
                <li><strong>Work Responsibility (Pre-Joining Period):</strong></li>
              </ol>
            </>
          )}

          <div className="offer-page-number">Page 1</div>
        </div>
      </div>

      {/* Page 2 */}
      <div className="offer-page" style={{marginTop:'100px'}}>
        <div className="offer-content">
          {positionType === 'District Coordinator' && (
            <>
              <p><strong>Date of Joining:</strong> {formatDate(data.joiningDate)}</p>
              <p>You are expected to join on the above-mentioned date unless mutually revised.</p>
              <p>This offer is valid for 15 (fifteen) days from the date of issuance. Failure to submit your acceptance via email within this period will result in the offer being automatically cancelled.</p>
              <p>Any dispute arising from this appointment will fall under the exclusive jurisdiction of the Delhi Court.</p>
            </>
          )}

          {positionType === 'Commissioner Manager' && (
            <>
              <p>You will be responsible for supervising and developing District Coordinators within these districts under your commissionery.</p>
              <p>Bandhan Guru will provide you with the list of shortlisted candidates for the District Coordinator positions. You are required to select suitable candidates from this list and ensure that at least 60% of the required District Coordinators are successfully hired across the above districts.</p>
              <p>After hiring, you must provide online training to the selected District Coordinators and conduct a minimum of 2 days of field work with each of them. District Coordinators will receive their Joining Letter only after completing online training, completing the required field activity, and adding at least 10 vendors to the Bandhan platform. All submissions sold by District Coordinators during this process will be counted toward the overall target achievement of your commissionery.</p>
              <p>Please note that this is only an Offer Letter. {data.salaryDescription}</p>
              <p>This offer is valid for 15 (fifteen) days from the date of issue. If we do not receive your acceptance by email within this period, the offer will be considered automatically cancelled.</p>
              <p>Any legal matter related to this offer or future employment shall fall under the exclusive jurisdiction of the Delhi Court.</p>
              <p>We look forward to your acceptance.</p>
            </>
          )}

          {positionType === 'State Head' && (
            <>
              <p>During this period, your responsibility will be to ensure that Commissionery Managers and District Coordinators in your state (<strong>{data.state}</strong>) achieve their targets.</p>
              <h3>4. Compensation (Post-Joining):</h3>
              <ul>
                <li><strong>Base Salary:</strong> {data.salaryDescription}</li>
                <li>Your salary will commence from the date of joining.</li>
              </ul>
              <h3>5. Performance-Linked Salary:</h3>
              <ul>
                <li>Your monthly salary will be directly proportional to the percentage of target achieved.</li>
                <li>If you achieve more than 100% of the target, your salary will increase proportionately.</li>
                <li>If achievement is partial, salary will be paid in proportion to performance.</li>
              </ul>
              <h3>6. Other Conditions:</h3>
              <ul>
                <li>The offer shall automatically stand cancelled if the minimum 60% hiring requirement and district-wise 4 coordinators hiring condition are not met.</li>
                <li>You are expected to maintain the highest level of professionalism, dedication, and leadership.</li>
              </ul>
              <h3>Important Note</h3>
              <p>This letter is purely an Offer Letter and should not be construed as an Appointment or Joining Letter. Your formal Joining Letter will be issued only after you fulfill the mandatory conditions mentioned in Clause 1 above.</p>
            </>
          )}

          <p>For Bandhan Guru</p>

          <div className="offer-signature-section">
            <div className="offer-signature-left">
              <img src="/uploads/signature.png" alt="Signature" className="offer-signature" />
              
            </div>
            <div className="offer-stamp-right">
              <img src="/uploads/stamp.png" alt="Company Stamp" className="offer-stamp" />
            </div>
          </div>
          <p>Authorized Signatory</p>
          <p><strong>Date:</strong> {formatDate(data.date)}</p>

          {positionType === 'State Head' && (
            <>
              <h3>Accepted & Signed by Candidate</h3>
              <ul style={{ listStyle: 'none', padding: 0 }}>
                <li><strong>Candidate Name:</strong> _______</li>
                <li><strong>State:</strong> ___________</li>
                <li><strong>Signature:</strong> ___________</li>
                <li><strong>Date:</strong> ___________</li>
              </ul>
            </>
          )}

          <div className="offer-page-number">Page 2</div>
        </div>
      </div>
    </div>
  );
};

export default OfferLetterTemplate;